var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "help-circle",
    clipPath: "url(#clip0_2206_11273)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M6.05998 6.00016C6.21672 5.55461 6.52608 5.1789 6.93328 4.93958C7.34048 4.70027 7.81924 4.61279 8.28476 4.69264C8.75028 4.77249 9.17252 5.01451 9.4767 5.37585C9.78087 5.73718 9.94735 6.19451 9.94665 6.66683C9.94665 8.00016 7.94665 8.66683 7.94665 8.66683M7.99998 11.3335H8.00665M14.6666 8.00016C14.6666 11.6821 11.6819 14.6668 7.99998 14.6668C4.31808 14.6668 1.33331 11.6821 1.33331 8.00016C1.33331 4.31826 4.31808 1.3335 7.99998 1.3335C11.6819 1.3335 14.6666 4.31826 14.6666 8.00016Z",
    stroke: "#98A2B3",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2206_11273"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/HelpIcon.df0e9d517f57580151fd456ae699d12b.svg";
export { ForwardRef as ReactComponent };